"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function CurateddataMulticolorOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE5FF",
    d: "M6.94 9.692a3.7 3.7 0 100-7.399 3.7 3.7 0 000 7.399z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M1.6 10.95a.6.6 0 01-.6-.599v-8.67A1.682 1.682 0 012.678 0h5.401a.6.6 0 110 1.198H2.678a.483.483 0 00-.48.484v8.67a.6.6 0 01-.599.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.175 3.492l2.042 2.041v9.097a.176.176 0 01-.172.171H4.563a.18.18 0 01-.175-.171V3.663a.18.18 0 01.175-.171h6.612zm.5-1.199H4.563a1.374 1.374 0 00-1.374 1.37V14.63A1.374 1.374 0 004.563 16h8.466a1.375 1.375 0 001.37-1.37V5.042l-2.74-2.74.016-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.476 3.492v2.74h2.74v8.486a.088.088 0 01-.087.084H4.476a.092.092 0 01-.088-.084V3.579a.096.096 0 01.088-.087h6zm1.19-1.199h-7.19A1.29 1.29 0 003.189 3.58v11.139A1.287 1.287 0 004.476 16h8.653a1.286 1.286 0 001.286-1.282V5.034h-2.74v-2.74h-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.802 13.879c-1.826 0-3.196-.723-3.196-1.678V8.17c0-.955 1.382-1.678 3.196-1.678 1.814 0 3.196.723 3.196 1.678v4.03c.012.956-1.366 1.679-3.196 1.679zm0-6.588c-1.446 0-2.397.531-2.397.879v4.03c0 .348.963.88 2.397.88 1.434 0 2.397-.532 2.397-.88V8.17c.012-.348-.967-.88-2.397-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.802 9.828c-1.83 0-3.196-.72-3.196-1.678 0-.959 1.378-1.678 3.196-1.678 1.818 0 3.196.723 3.196 1.678s-1.366 1.678-3.196 1.678zm0-2.557c-1.446 0-2.397.531-2.397.879 0 .347.963.879 2.397.879 1.434 0 2.397-.528 2.397-.88 0-.35-.967-.878-2.397-.878zM8.802 13.859c-1.83 0-3.196-.723-3.196-1.678h.8c0 .347.962.879 2.396.879s2.397-.532 2.397-.88h.8c.011.956-1.367 1.679-3.197 1.679zM6.393 10.011h-.799v2.166h.8v-2.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.393 8.15h-.799v1.861h.8V8.15zM12.01 8.15h-.799v4.027h.8V8.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.802 11.69c-1.83 0-3.196-.72-3.196-1.678h.8c0 .351.962.878 2.396.878s2.397-.527 2.397-.879h.8c.011.96-1.367 1.678-3.197 1.678z"
  }));
}

CurateddataMulticolorOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
CurateddataMulticolorOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = CurateddataMulticolorOutline;
exports["default"] = _default;